import React from 'react';
import { connect } from 'react-redux';
import { Card, CardBlock, CardTitle , Button} from 'reactstrap';

import ReactTable from "react-table";
import "react-table/react-table.css";
import IconEdit from 'react-icons/lib/md/edit';
import IconPersonAdd from 'react-icons/lib/md/person-add';

import {api,API_UR} from '../../actions/_request';
import * as actions from '../../actions/categorias';

import Modal from "./modal";


class Categoria extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            modal       : false,
            prospectoid : null,
            title       : "",
            data : [],
        };
        this.toggle 			= this.toggle.bind(this);

    }

   

    componentDidMount(){
		this.props.get();
	}

    toggle(evt, prospectoid = null, title = "Agregar Categoria")
    {
        //let {modal} = this.state;

        this.setState({
            modal       : !this.state.modal,
            prospectoid : prospectoid,
            title       : title,
            
        });

        //console.log(prospectoid)

    }

    render() {
        console.log(this.props.categorias.data);

        return(
            <div className="view">

                <div className="view-header">
                    <header className="title text-white">
                        <h1 className="h4 text-uppercase">Categorias</h1>
                    </header>
                </div>

                <div className="view-content view-components">
                    <Card>
                        <CardBlock>
                        <div className="text-right">
                                <Button color="success" className="mb-2" onClick={this.toggle}>
                                    Agregar
                                </Button>
                            </div>
                            <ReactTable
                              data      = {this.props.categorias.data}
                              className = "-striped -highlight"
                              columns   = {[
                               
                                {Header: 'Categoria', accessor: 'label'},
                                {
                                    Header: 'Controles',
                                    filterable: false,
                                    sortable: false,
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-right">
                                                <Button
                                                 color="success" 
                                                 className="btn-sm" 
                                                 onClick={(evt)=>this.toggle(evt, row.original.value, 'Editar Categoria')}>
                                                    <IconEdit />
                                                </Button>{' '}
                                                 
                                            </div>
                                        )
                                    }
                                }
                              
                              ]}
                              filterable 
                              defaultPageSize={10} 
                              defaultFilterMethod={(filter, row) => {
                                var patt = new RegExp(filter.value, "i");
                                return row[filter.id].search(patt) > -1 || row[filter.id].search(patt) > -1;
                              }}
                             
                              
                             
                            />
                        </CardBlock>
                    </Card>
                </div>
                {
                   this.state.modal&& 
                   <Modal 
                 open={this.state.modal} 
                 toggle={this.toggle} 
                 title={this.state.title} 
                 prospectoid={this.state.prospectoid}
                />
                }
                 

            </div>
        );
    }

};

function mapStateToProps(state, ownProps) {
    return {
          categorias: state.categorias,
        
    }
};

export default connect(mapStateToProps,actions)(Categoria)



// WEBPACK FOOTER //
// ./src/views/categorias/index.js